import React from 'react'

function Select({ children, no_rounded, ...rest }) {
    return (
        <select
            {...rest}
            className={`px-5 py-3 ${no_rounded ? 'rounded-lg' : "rounded-full"} w-full border`}
        >
            {children}
        </select>
    )
}

export default Select